<div class="rxnt-progress-placeholder"
     [class.rxnt-hidden]="!show">

  @if (show) {
    <div class="rxnt-progress-container">
      <div class="rxnt-progress-bar"
           [style.animation-duration]="animationDuration"></div>
    </div>
  }
</div>
